import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Calendar } from "lucide-react";
import { lazy } from "react";

const PlanningView = lazy(() =>
  import("@/features/rh/planning/components/PlanningView").then((m) => ({
    default: m.PlanningView,
  })),
);

// Planning uses Feuilles de Temps permissions for HR planning management
export const Route = createFileRoute("/_app/rh/planning/")({
  loader: async ({ context }) => {
    await requirePermission(PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW)({ context });
  },
  staticData: {
    title: "Planning",
    icon: Calendar,
    tab_icon: Calendar,
    permission: PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW,
    module: "rh",
    section: "Ressources Humaines",
    order: 30,
    showInNav: true,
    showInTab: true,
  },
  component: function PlanningPage() {
    // HR view = has Feuilles de Temps permission
    return <PlanningView isHR={true} />;
  },
});
